
import React, { useState, useEffect } from 'react';
import { Badge } from '@/components/ui/badge';
import { replaceLocationVariables, fetchLocationByName } from '@/utils/variableReplacer';

interface CategoryBadgeProps {
  category: string;
  locationName: string | null;
}

const CategoryBadge: React.FC<CategoryBadgeProps> = ({ category, locationName }) => {
  const [displayCategory, setDisplayCategory] = useState(category);

  useEffect(() => {
    if (!locationName) {
      setDisplayCategory(category);
      return;
    }

    const loadCategoryPreview = async () => {
      try {
        const location = await fetchLocationByName(locationName);
        if (location) {
          const replacedCategory = replaceLocationVariables(category, location);
          setDisplayCategory(replacedCategory);
        }
      } catch (error) {
        console.error('Error loading category preview:', error);
        setDisplayCategory(category);
      }
    };

    loadCategoryPreview();
  }, [category, locationName]);

  return (
    <Badge variant="secondary" className="text-xs">
      {displayCategory}
    </Badge>
  );
};

export default CategoryBadge;
